"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BIRTHPLACE = exports.MAILING = exports.PHYSICAL = void 0;
exports.PHYSICAL = "physical";
exports.MAILING = "mailing";
exports.BIRTHPLACE = "birthplace";